import { queryOnScope, getSelector, isInsideSameKeynav, active } from './utils';
export const initTabIndexes = (scopeElements, selectorOptions, keynavId) => {
    const getFocusables = (scope) => {
        var _a;
        const selector = getSelector(selectorOptions);
        const focusables = (_a = queryOnScope(scope, selector)) === null || _a === void 0 ? void 0 : _a.filter((el) => isInsideSameKeynav(el, keynavId));
        if (!focusables || focusables.length < 1)
            return null;
        return focusables;
    };
    scopeElements.forEach((el) => setTabIndex(getFocusables(el)));
    const handleFocus = () => scopeElements.forEach((el) => setTabIndex(getFocusables(el)));
    const allFocusables = getFocusables(scopeElements);
    allFocusables === null || allFocusables === void 0 ? void 0 : allFocusables.forEach((el) => {
        el === null || el === void 0 ? void 0 : el.addEventListener('focusin', handleFocus);
        el === null || el === void 0 ? void 0 : el.addEventListener('focusout', handleFocus);
    });
    return allFocusables === null || allFocusables === void 0 ? void 0 : allFocusables.map((el) => () => {
        el === null || el === void 0 ? void 0 : el.removeEventListener('focusout', handleFocus);
        el === null || el === void 0 ? void 0 : el.removeEventListener('focusin', handleFocus);
    });
};
const setTabIndex = (els) => {
    if (!els || (els === null || els === void 0 ? void 0 : els.length) < 1)
        return;
    // One element should always be focusable, having `tabIndex=0`
    const keepFocusable = findActive(els) || findSelected(els) || findLastFocused(els) || els[0];
    els.forEach((el) => (el.tabIndex = -1));
    keepFocusable.tabIndex = 0;
};
const findLastFocused = (els) => {
    const result = els === null || els === void 0 ? void 0 : els.filter((el) => (el === null || el === void 0 ? void 0 : el.hasAttribute('tabIndex')) && el.tabIndex >= 0);
    if ((result === null || result === void 0 ? void 0 : result.length) === 1)
        return result[0];
    return null;
};
const findSelected = (els) => {
    const result = els === null || els === void 0 ? void 0 : els.find((el) => el === null || el === void 0 ? void 0 : el.matches([
        '[aria-current]:not([aria-current=false])',
        '[aria-checked]:not([aria-checked=false])',
        '[aria-selected]:not([aria-selected=false])',
        '[aria-pressed]:not([aria-pressed=false])',
    ].join(':not([aria-disabled=true]),')));
    if (result)
        return result;
    return null;
};
const findActive = (els) => {
    if (els === null || els === void 0 ? void 0 : els.includes(active()))
        return active();
    return null;
};
//# sourceMappingURL=tabIndex.js.map